import { useState } from "react";

interface DegreesButtonSubInputProps {
  defaultValue: string | null;
  onInputChange?: (...values: unknown[]) => void;
  disabled?: boolean;
}

const options = ["0-30", "30-60", "60-75", "75-90"];

function DegreesButtonSubInput({
  defaultValue,
  onInputChange,
  disabled,
}: DegreesButtonSubInputProps){
  const [value, setValue] = useState(defaultValue ?? options[0]);
  const onClick = (option: string) => (): void => {
    setValue(option);
    if (onInputChange) {
      onInputChange(option);
    }
  };

  return (
    <div className="border-rmh-gray-300 divide-rmh-gray-300 flex w-full divide-x overflow-hidden rounded-2xl border ">
      {options.map((option) => {
        return (
          <button
            className={`text-rmh-gray-800 flex-1 px-1 py-2 text-xs font-semibold ${
              option === value
                ? " bg-rmh-blue-25 text-rmh-blue-700"
                : "bg-white"
            }`}
            disabled={disabled}
            key={option}
            onClick={onClick(option)}
            type="button"
          >
            {option}
          </button>
        );
      })}
    </div>
  );
}

export default DegreesButtonSubInput;
